@for (tag of availabletagList; track tag) {
  <ux-tag class="task-view-tag__item" [model]="tag"></ux-tag>
}
<div class="task-view-tag__add-tag-wrapper">
  <span #addButton class="task-view-tag__add" (click)="onOpen($event)">
    <i class="icon-plus"></i>
  </span>
</div>
@if (isOpen) {
  <ux-popup-tag
    #popupTag
    class="task-view-tag__add-tag-popup"
    [style.top.px]="popupTopPosition()"
    [value]="tags"
    [projectId]="projectId()"
    (clickOutside)="onClose()"
    [delayClickOutsideInit]="true"
    [multiple]="true"
    (selectItem)="onSelect($event)"
  >
  </ux-popup-tag>
}
